<script>
import constants from "./../mixins/constants";

export default {
  name: "sidebar",
  props: ["segments"],
  mixins: [constants],
  data: () => ({
    entity: {},
    showEntityItems: false,
    current: "",
    entityItems: [
      {
        title: "Panel de Control",
        name: "control-panel",
        icon: "fa-hexagon",
        url: "/",
        active: false
      },
      {
        title: "Centro médico",
        name: "branches",
        icon: "fa-hospital",
        url: "/",
        active: false
      },
      {
        title: "Profesionales",
        name: "professionals",
        icon: "fa-user-md",
        url: "/",
        active: false
      },
      {
        title: "Usuarios",
        name: "users",
        icon: "fa-user-friends",
        url: "/",
        active: false
      }
    ],
    items: [
      {
        title: "Entidades",
        name: "entities",
        icon: "fa-hospitals",
        url: "/entities",
        active: false
      },
      {
        title: "Administradores",
        name: "administrators",
        icon: "fa-user-cog",
        url: "/administrators",
        active: false
      },
      {
        title: "Prevision",
        name: "previsions",
        icon: "fa-files-medical",
        url: "/previsions",
        active: false
      },
      {
        title: "Especialidades",
        name: "specialities",
        icon: "fa-notes-medical",
        url: "/specialities",
        active: false
      }
    ]
  }),

  mounted() {
    const segments = JSON.parse(this.segments);
    const [entity] = Object.values(segments)
      .map(Number)
      .filter(Boolean);
    const [current] = Object.values(segments)
      .map(String)
      .filter(Boolean);

    this.entityItems = this.entityItems.map(el => ({
      ...el,
      url: `/entities/${entity}/${el.name}`,
      active: segments.indexOf(el.name) >= 0
    }));

    this.items = this.items.map(el => ({
      ...el,
      active: segments.indexOf(el.name) >= 0
    }));

    this.showEntityItems = !isNaN(entity) && current === "entities";
    if (this.showEntityItems && current === "entities") {
      this.getEntity(entity);
    }
  },
  methods: {
    async getEntity(id) {
      const { data } = await axios.get("/entity/" + id);
      const [entity] = data.data;

      this.entity = entity;
    }
  }
};
</script>
<style lang="scss" scoped>
.sidebar {
  position: sticky;

  .nav-items {
    flex-direction: column !important;
  }
}

.avatar-entity-sidebar {
  width: 32px;
  height: 32px;
  object-fit: cover;
}

@media screen and (max-width: 768px) {
  .sidebar {
    height: 100vh;
    position: absolute;
    z-index: 1040;
    background-color: #fff;
    width: 100%;
    top: 0;

    .sidebar-entity {
      box-shadow: none !important;
      border-radius: 0;
    }

    .sidebar-title {
      padding-left: 1rem;
    }
  }
}

@media screen and (max-width: 768px) {
  .sidebar {
    display: none;

    &.show-sidebar {
      display: block;
      overflow: hidden;
    }
  }
}

.nav-link {
  padding: 0.75rem 1rem;
  margin-bottom: 0.5rem;
  color: #092f6d;

  &.router-link-exact-active {
    background: #092f6d;
    color: #fff;

    &:hover {
      background: #092f6d !important;
    }

    .icon-link {
      color: #fff;
    }
  }

  &:hover {
    background: #dcdcdd;
  }
}

.sidebar-entity {
  .nav-link {
    border-radius: 0;

    &.router-link-exact-active {
      background: rgba(#37a56d, 0.1);
      color: #05c08a;

      &:hover {
        background: rgba(#37a56d, 0.3) !important;
      }

      .icon-link {
        color: #05c08a;
      }
    }
  }
}

.icon-link {
  width: 1.5rem;
  font-size: 0.8rem;
  margin: 0 auto;
  color: #092f6d;

  &:active {
    color: #fff;
  }
}

@media screen and (max-width: 770px) {
  .nav-link {
    border-radius: 0;
    padding: 0.875rem 1.5rem;
    border-bottom: 1.5px solid transparent;
    margin-bottom: 0;

    &.router-link-exact-active {
      background: transparent;
    }
  }
}
</style>
